import { FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../../base/hooks";
import { IDropdownProps } from "./IDropdownProps";

export const DropdownProperties = [
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.Dropdown, name: 'Options', type: PropertyType.Dropdown },
    { id: Property.Placeholder, name: 'Placeholder', type: PropertyType.String },
    { id: Property.Required, name: 'Required', type: PropertyType.Boolean },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useDropdownProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IDropdownProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IDropdownProps = {
            label: bindings.getValue(Property.Label) || '',
            title: bindings.getValue(Property.Tooltip) || '',
            placeholder: bindings.getValue(Property.Placeholder) || '',
            options: bindings.getValue(Property.Dropdown) || [],
            value: bindings.getValue(Property.InitValue) || '',
            required: bindings.getValue(Property.Required) || false,
            disabled: bindings.getValue(Property.Disabled) || false
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}